import { useFlag } from '@/features/unleash';
import { NarrativeFairValueModal } from './NarrativeFairValueModal';
import { NarrativeFairValueModal as NarrativeFairValueModalDeprecated } from './NarrativeFairValueModalDeprecated';
import { ComponentProps } from 'react';

type NarrativeFairValueModalProps = ComponentProps<
  typeof NarrativeFairValueModal
> &
  ComponentProps<typeof NarrativeFairValueModalDeprecated>;

export const FlaggedNarrativeFairValueModal = (
  props: NarrativeFairValueModalProps
) => {
  const { flagsReady, enabled } = useFlag({
    name: 'mono-narratives-fv-modal-new-layout',
  });

  if (flagsReady && enabled) return <NarrativeFairValueModal {...props} />;
  return <NarrativeFairValueModalDeprecated {...props} />;
};
